import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  constructor(private http: HttpClient) { }

  activeTab = 0;

  public getTransactionList(filterPayload: any, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.transactionList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint)
  }

  public getTransactionListCommon(filterPayload: any, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.transactionListCommon, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint)
  }

  public getTransactionListRad(filterPayload: any, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.transactionListRad, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint)
  }
  public getTransactionListLab(filterPayload: any, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.transactionListLab, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint)
  }
  public getTransactionListByPayer(filterPayload: any, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.payerList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint);
  }
  public getTransactionListByProvider(filterPayload: any, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.providerList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public getTransactionDetails(id: string): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.getTransactionDetails, null, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public setApprovalStatus(id: number, payLoad: Record<string, string | number>): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.authorization.setPreApprovalStatus, null, { id });
    return this.http.put<ApiResponse>(endpoint, payLoad)
  }

  public getAllTabs(payload: { generatorType: string }): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.prescription.getAllTabs, payload);
    return this.http.get<ApiResponse>(endpoint);
  }

  public exportList(filterPayload: Record<string, string | number | object | null>) {
    let endpoint = getApiUrl(apiList.prescription.getEport, filterPayload);
    return this.http.get(endpoint, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }, responseType: 'blob', observe: 'response'
    });
  }
}
